module.exports = __webpack_public_path__ + "static/media/user-friends.e4a39cab.svg";